import React, { forwardRef } from 'react';
import MenuItemBase from '@material-ui/core/MenuItem';

const MenuItem = forwardRef((props, ref) => (
  <MenuItemBase ref={ref} {...props} />
));

export default MenuItem;
